import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../../styles/client/ClientConfirmation.css';

const ClientConfirmation = () => {
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get('quote_id');

  return (
    <div className="client-confirmation-page">
      <div className="confirmation-container">
        <div className="confirmation-icon">✅</div>
        
        <h1>Devis accepté avec succès!</h1>
        
        <div className="confirmation-message">
          <p>Merci d'avoir accepté notre devis.</p>
          <p>Votre compte client a été créé et vous pouvez maintenant accéder à votre espace personnel.</p>
        </div>

        <div className="confirmation-info">
          <h3>📋 Prochaines étapes:</h3>
          <ul>
            <li>Vous recevrez une confirmation par courriel sous peu</li>
            <li>Notre équipe vous contactera pour planifier les travaux</li>
            <li>Vous pouvez télécharger votre devis depuis votre espace client</li>
          </ul>
        </div>

        <div className="confirmation-actions">
          <Link to="/client/dashboard" className="btn-dashboard">
            🏠 Accéder à mon espace client
          </Link>
          
          {quoteId && (
            <a 
              href={`${process.env.REACT_APP_BACKEND_URL}/api/erp/quotes/${quoteId}/pdf`}
              className="btn-download"
              target="_blank"
              rel="noopener noreferrer"
            >
              📥 Télécharger le PDF
            </a>
          )}
        </div>

        <div className="confirmation-contact">
          <p>Des questions? Contactez-nous:</p>
          <p>📞 <strong>450-XXX-XXXX</strong></p>
          <p>📧 <strong>info@nvfertilisation.com</strong></p>
        </div>
      </div>
    </div>
  );
};

export default ClientConfirmation;
